import * as React from 'react';
import { Hr } from '@grandvisionhq/elements';
import '../../../../../../context/actions.js';
import '../../../../../../context/reducer.js';
import { useProductData } from '../../../../../../context/product-context-hooks.js';
import '../../../../../../context/ProductContext.js';
import '../../../../../../context/CmsContext.js';

const EmptyTree = ({ treeVariants  })=>{
    var ref1;
    const { facetConfigList  } = useProductData();
    const facetConfig = facetConfigList === null || facetConfigList === void 0 ? void 0 : facetConfigList.find((config)=>{
        var ref;
        return config.facetKey === ((ref = treeVariants[0]) === null || ref === void 0 ? void 0 : ref.facetKey);
    });
    const Right = facetConfig === null || facetConfig === void 0 ? void 0 : (ref1 = facetConfig.slots) === null || ref1 === void 0 ? void 0 : ref1.Right;
    if (!Right) return null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Right, {
        treeLevelVariants: treeVariants,
        facetKey: facetConfig.facetKey
    }), /*#__PURE__*/ React.createElement(Hr, null));
};

export { EmptyTree };
//# sourceMappingURL=EmptyTree.js.map
